<template>
  <div class="pt-6">
    <forecastsReportsPage
      :category="category"
      :category-report="SUBSCRIPTION_FORECASTS_COPPER"
      :product="slug"
    />
  </div>
</template>

<script lang="ts" setup>
import forecastsReportsPage from '~/components/shared/forecasts/ReportsPage.vue'
import {
  COPPER,
  SUBSCRIPTION_FORECASTS_COPPER,
} from '~/constants/services/constants'
import { computed } from 'vue'

definePageMeta({ isTab: true })

const category = computed(() => COPPER.category)
const slug = computed(() => COPPER.slugForecast || COPPER.slug)
</script>
